import { atom, useAtom } from "jotai";
import { useHistory } from "react-router-dom";
import useStore from "../../context/useStore";

export const ESPACES = { PARTICULIER: "PARTICULIER", ENTREPRISE: "ENTREPRISE" };

// Choix de session d'un profil MIXED (null = pas encore basculé : on lit le localStorage)
const espaceChoisiAtom = atom(null);

const cleStockage = (email) => `espaceActif:${email}`;

const lireChoixMemorise = (email) => {
  try {
    const valeur = localStorage.getItem(cleStockage(email));
    return valeur === ESPACES.PARTICULIER || valeur === ESPACES.ENTREPRISE ? valeur : null;
  } catch {
    return null;
  }
};

// Source de vérité unique de l'espace affiché (PER-2406). Aucun composant ne
// lit clientProfile directement pour de l'affichage : tout passe par ce hook.
const useEspaceActif = () => {
  const [state] = useStore();
  const history = useHistory();
  const [espaceChoisi, setEspaceChoisi] = useAtom(espaceChoisiAtom);
  const { clientProfile, email } = state.auth.user;

  const peutBasculer = clientProfile === "MIXED";

  let espace;
  if (clientProfile === "INDIVIDUAL" || clientProfile === "NONE") {
    espace = ESPACES.PARTICULIER;
  } else if (peutBasculer) {
    espace = espaceChoisi || lireChoixMemorise(email) || ESPACES.ENTREPRISE;
  } else {
    // COMPANY, profil absent (JWT antérieur à PER-2389) ou valeur inconnue :
    // comportement historique de l'app
    espace = ESPACES.ENTREPRISE;
  }

  const basculer = (nouvelEspace) => {
    if (!peutBasculer || nouvelEspace === espace) return;
    try {
      localStorage.setItem(cleStockage(email), nouvelEspace);
    } catch {
      // stockage indisponible : la bascule vaut pour la session (atom)
    }
    setEspaceChoisi(nouvelEspace);
    history.push("/accueil");
  };

  return { espace, peutBasculer, basculer };
};

export default useEspaceActif;
